import produce from 'immer';
import {
    SHOW_LOADING,
    SHOW_PROFILE,
    SHOW_STORY,
    SHOW_RECEIPT
} from 'shared/actions/types';

const initialState = {
    home: {
        hidden: false,
        state: SHOW_STORY,
        isLoading: false
    },
    receipt: {
        purchase: null
    }
}

export default function (state = initialState, action) {
    switch (action.type) {
        case SHOW_PROFILE:
            return produce(state, draft => {
                draft.home.state = SHOW_PROFILE
            });

        case SHOW_STORY:
            return produce(state, draft => {
                draft.home.state = SHOW_STORY
            });

        case SHOW_LOADING:
            return produce(state, draft => {
                draft.home.state = SHOW_LOADING;
                draft.home.isLoading = action.payload;
            });

        case SHOW_RECEIPT:
            return produce(state, draft => {
                draft.home.state = SHOW_RECEIPT
                draft.receipt.purchase = action.payload
            });

        default:
            return state;
    }
}
